import { getAccountScopeUserConfiguration } from 'mini-common-utils/lib/utils/getAccountScopeUserConfiguration';

export const getAllOnboardingCardsShownStatus = () => {
    const primeSettings = getAccountScopeUserConfiguration().PrimeSettings;

    const onboardingCampaignOptions = primeSettings?.Items?.find(
        primeSetting => primeSetting.Id === 'OnboardingCampaignOptions'
    );

    const allOnboardingCardsShown: boolean =
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
         * See aka.ms/mini-lint-errors
         *	> Unexpected any. Specify a different type. */
        (onboardingCampaignOptions?.Value?.options?.[0]?.allOnboardingCardsShown as any) || false;

    return allOnboardingCardsShown;
};
